export enum SortOrder {
  OLDEST_FIRST = 'OLDEST_FIRST',
  NEWEST_FIRST = 'NEWEST_FIRST',
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING',
}
